import { Box } from "@mui/material";
import { styled } from "@mui/system";
import bgImage from "../../../../assets/images/about-tedx-bg.webp";

const StyledWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  position: "relative",
  padding: "100px 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.primary.main,
  overflow: "hidden",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backgroundImage: `url(${bgImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    mixBlendMode: "multiply",
    zIndex: 0,
    pointerEvents: "none",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(180deg, rgba(235,0,40,0) 0%, rgba(235,0,40,0) 35%, rgba(235,0,40,0.6) 65%, #EB0028 100%)",
    zIndex: 0,
    pointerEvents: "none",
  },
  [theme.breakpoints.down("md")]: {
    padding: "70px 0",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "50px 0",
  },
  ".about-tedx-content-container": {
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  ".about-tedx-content": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    maxWidth: "1100px",
    [theme.breakpoints.down("md")]: {
      gap: "16px",
    },
  },
  ".about-tedx-title": {
    color: theme.palette.white.main,
    textAlign: "center",
    margin: 0,
  },
  ".about-tedx-subtitle": {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "20px",
    lineHeight: 1.4,
    color: theme.palette.white.main,
    textAlign: "center",
    marginBottom: "20px",
    [theme.breakpoints.down("md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "14px",
      marginBottom: "8px",
    },
  },
  ".about-tedx-description": {
    color: `${theme.palette.white.main} !important` as string,
    textAlign: "center !important" as "center",
    maxWidth: "none !important" as "none",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center !important" as "center",
    },
  },
}));

export default StyledWrapper;
